import { computed } from 'vue'
import utils from '@/services/utils'
import { appConstants } from '@/models/constants'
import { useUserStore } from '@/store/userData'

export default function useFilterableAttributes() {
  const userStore = useUserStore()

  const filterableAttributes = computed(() => {
    const filterableAttributeNames = new Set()
    const res: IMyAttribute[] = []
    const allowedAttrs = new Set(
      userStore.activeCatalog?.Config.FilterableAttributes ?? [],
    )
    for (const attributeSystemName in appConstants.staticAttributes) {
      const staticAttribute = appConstants.staticAttributes[attributeSystemName]
      if (staticAttribute.AllowFiltering && allowedAttrs.has(attributeSystemName) && !filterableAttributeNames.has(staticAttribute.SystemName)) {
        res.push(staticAttribute)
        filterableAttributeNames.add(staticAttribute.SystemName)
      }
    }
    const filterableAttributes: IMyAttribute[] = []
    if (userStore.activeCatalog && allowedAttrs.size !== 0 && utils.isDefined(userStore.myAttributes)) {
      for (const filterableAttribute of allowedAttrs) {
        if (userStore.myAttributes[filterableAttribute] && !filterableAttributeNames.has(filterableAttribute)) {
          filterableAttributes.push(userStore.myAttributes[filterableAttribute])
          filterableAttributeNames.add(filterableAttribute)
        }
      }
      if (userStore.activeCatalog.RequestsEnabled > 0
        && userStore.activeCatalog.RequestAttributeList && userStore.activeCatalog.RequestAttributeList.length) {
        userStore.activeCatalog.RequestAttributeList.forEach((requestAttribute) => {
          if (allowedAttrs.has(requestAttribute.AttributeSystemName) && requestAttribute.Status > 0 && utils.isDefined(userStore.myAttributes![requestAttribute.AttributeSystemName])
            && !filterableAttributeNames.has(requestAttribute.AttributeSystemName)) {
            filterableAttributes.push(userStore.myAttributes![requestAttribute.AttributeSystemName]!)
            filterableAttributeNames.add(requestAttribute.AttributeSystemName)
          }
        })
      }
    }
    if (filterableAttributes.length) {
      res.push(...filterableAttributes.sort((a, b) => a.DisplayName.toLowerCase() > b.DisplayName.toLowerCase() ? 1 : a.DisplayName.toLowerCase() < b.DisplayName.toLowerCase() ? -1 : 0))
    }
    return res
  })

  const filterableAttributesByAttributeSystemName = computed(() => filterableAttributes.value.reduce((acc, cur) => {
    acc[cur.SystemName] = cur
    return acc
  }, {} as Record<string, IMyAttribute>))

  return {
    filterableAttributes,
    filterableAttributesByAttributeSystemName,
  }
}
